import { useSelector } from 'react-redux';
import { MenuState } from '@/reducers/menu';

export default function useMenu() {
  const menu = useSelector((state: { menu: MenuState }) => state.menu.menu);
  const error = useSelector((state: { menu: MenuState }) => state.menu.error);

  return [menu, error.status] as const;
}
